// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

//  *** Note: Instrumentation key is temporary so we can verify entries are being made.
//  Remove from here once done.

export const environment = {
  production: false,
  envName: 'uat',
  applicationName: 'Inmar.Healthcare.Cm',
  applicationApplinkFeature: 'ContractManagement::AllUsers',
  applicationDisplayName: 'CONTRACT MANAGEMENT',
  healthcareTopBar:
    'https://qa-web-auth.healthcare.inmar.com/Scripts/healthcare-topbar-v2.js',
  auth0: {
    domain: 'ut-login.healthcare.inmar.com',
    clientId: 'RhDIMX5dSmPeInBZQbm4Htw4HdLp1EA5',
    refreshToken: true,
    scope: 'openid profile email',
  },
  authZApiRoot: {
    url: 'https://qa-api-authz.healthcare.inmar.com/v1.0',
    audience: 'https://qa-api-authz.healthcare.inmar.com',
  },
  cmUrlRoot: 'https://uat-web-cm.healthcare.inmar.com',
  cmApiRoot: {
    url: 'https://uat-api-cm.healthcare.inmar.com',
    audience: 'https://uat-api-cm.healthcare.inmar.com',
  },
  lookerAnalyticsRoot: 'https://devpfmanalytics.cloud.looker.com',
  lookerAdminRoot: {
    url: 'https://uat-api-lookeradmin.healthcare.inmar.com',
    audience: 'https://uat-api-lookeradmin.healthcare.inmar.com',
  },
};
